/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';

export class CustomerSummaryVoModel extends JSONable {
  uuid: string | undefined = undefined;
  customerUuid: string | undefined = undefined;
  customerName: string | undefined = undefined;
  uniqueIdNumber: string | undefined = undefined;
  territory: string | undefined = undefined;
  loyaltyCode: string | undefined = undefined;
  customerStage: string | undefined = undefined;
  salesName: string | undefined = undefined;
  salesChannel: string | undefined = undefined;
}
